<nav
  id="navbar-main"
  class="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light"
>
  <div class="container">
    <a class="navbar-brand">
      <img
        src="assets/img/ieeg/logoBlanco.png"
        style="width: 100px; height: 50px"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbar-collapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseBasic"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="navbar-collapse navbar-custom-collapse collapse"
      id="collapseBasic"
      [collapse]="isCollapsed"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a>
              <img src="assets/img/ieeg/logoColor.png" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button
              type="button"
              class="navbar-toggler"
              data-toggle="collapse"
              data-target="#navbar-collapse"
              aria-controls="navbar-collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              (click)="isCollapsed = !isCollapsed"
            >
              <span></span> <span></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
<footer class="py-5">
  <div class="container">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-6">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ currentDate }}
          <a
            href="https://www.ieeg.mx/"
            class="font-weight-bold ml-1"
            target="_blank"
            >IEEG</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
